import { Box } from "@mui/material";
import React from "react";
import CustomTable from "../../../components/CustomTable";
import DashboardTopTitle from "../../../components/DashboardTopTitle";
import { AddCircleOutline } from "@mui/icons-material";

const Transactions = () => {
  return (
    <Box>
      <DashboardTopTitle
        title="Transaction Activities"
        onClickFirst={() => {}}
        secondBtnIcon={<AddCircleOutline />}
        secondBtnTitle="New Appointment"
        secondBtn
      />
      <CustomTable onClick={() => {}} />
    </Box>
  );
};

export default Transactions;
